// extracted by mini-css-extract-plugin
module.exports = {"bar":"StickyNav_bar__P2_b6","booker":"StickyNav_booker__8kuK4","link":"StickyNav_link__b_9ws"};